<template>
  <!-- begin:: Page -->
  <div class="container">
    <div class="row">
      <div class="bg-1">
        <div class="auth-header">
          <div class="auth-head-row">
            <button
              type="button"
              class="auth-theme-toggle"
              :aria-label="currentTheme === 'dark' ? 'فعال کردن حالت روشن' : 'فعال کردن حالت تاریک'"
              :aria-pressed="currentTheme === 'dark'"
              @click="toggleTheme"
            >
              <svg v-if="currentTheme === 'dark'" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="4" /><path d="M12 2.5v2" /><path d="M12 19.5v2" /><path d="M2.5 12h2" /><path d="M19.5 12h2" /><path d="M5 5l1.4 1.4" /><path d="M17.6 17.6L19 19" /><path d="M19 5l-1.4 1.4" /><path d="M6.4 17.6L5 19" />
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <path d="M11.01 3.05C6.51 3.54 3 7.36 3 12c0 4.97 4.03 9 9 9c4.63 0 8.45-3.5 8.95-8c.09-.79-.78-1.42-1.54-.95c-.84.54-1.84.85-2.91.85c-2.98 0-5.4-2.42-5.4-5.4c0-1.06.31-2.06.84-2.89c.45-.62-.04-1.56-.93-1.56z" />
              </svg>
            </button>
            <router-link to="/" class="login-header">
              <img :src="currentLogo" alt="Paystar Logo">
            </router-link>
          </div>
          <div v-if="$slots.tabs" class="auth-tabs">
            <slot name="tabs"></slot>
          </div>
        </div>
        <div class="bg-form bg-white shadow">
          <slot></slot>
        </div>
      </div>
      <div class="bg-2">
        <div class="bg-img shadow"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthLayout",
  data() {
    return {
      currentTheme: 'dark'
    }
  },
  computed: {
    currentLogo() {
      return require('@/assets/new/image/logo_new_dark.png');
    }
  },
  methods: {
    updateTheme() {
      this.currentTheme = window.localStorage.getItem('AppUiTheme') || 'dark';
    },
    toggleTheme() {
      this.setTheme(this.currentTheme === 'dark' ? 'light' : 'dark');
    },
    setTheme(theme) {
      theme = String(theme);
      window.localStorage.setItem('AppUiTheme', theme);
      this.currentTheme = theme;

      switch (theme) {
        case 'light':
          this.unloadDarkThemeCss();
          break;
        case 'dark':
          this.loadDarkThemeCss();
          break;
        default:
          this.setTheme('light');
          break;
      }

      window.dispatchEvent(new Event('themeChanged'));
    },
    loadDarkThemeCss() {
      if (document.getElementById('dark_theme_style_file')) return;
      let file = document.createElement('link');
      file.rel = 'stylesheet';
      file.id = 'dark_theme_style_file';
      file.href = '/assets/new/style/dark-theme.css';
      let parent = document.getElementById('dark_theme_style_container');
      if (parent) parent.appendChild(file);
    },
    unloadDarkThemeCss() {
      let element = document.getElementById('dark_theme_style_file');
      let parent = document.getElementById('dark_theme_style_container');

      if (element && parent) {
        parent.removeChild(element);
      }
    }
  },
  mounted() {
    this.updateTheme();
  }
}
</script>

<style scoped>
.container {
  max-width: 1700px;
  background-size: cover;
  margin: auto;
}
.bg-form {
  position: relative;
}
.auth-header {
  position: relative;
  width: 80%;
  margin: 0 auto;
}
.auth-head-row {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 14px;
}
.login-header {
  width: auto;
  margin: 0;
}
.login-header > img {
  width: 150px;
  display: block;
  background: transparent;
}
.auth-tabs {
  text-align: center;
  margin-top: 2px;
}
.bg-1 > .bg-form {
  float: none;
  width: 80%;
  height: calc(90% - 160px);
  margin: 10px auto 0;
  overflow: auto;
}
.auth-theme-toggle {
  position: absolute;
  top: 16px;
  left: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid rgba(128, 128, 128, 0.35);
  background: transparent;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease;
  z-index: 2;
}
.auth-theme-toggle:hover {
  color: #00bea5;
  border-color: #00bea5;
}
.auth-theme-toggle:focus-visible {
  outline: 2px solid #00bea5;
  outline-offset: 2px;
}
</style>

<style>
/* سرصفحه ورود/ثبت‌نام — بدون scope: تب‌ها از صفحات داخل اسلات می‌آیند */
.auth-tabs-switch {
  display: flex;
  width: max-content;
  margin: 10px auto 0;
  padding: 4px;
  gap: 4px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #e2e7e5;
  box-shadow: 0 2px 10px rgba(20, 16, 79, 0.07);
}
.auth-tab {
  display: inline-block;
  padding: 7px 26px;
  border-radius: 999px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #2b2b33;
  transition: background-color 0.25s ease, color 0.25s ease;
}
.auth-tab:hover {
  background: rgba(0, 190, 165, 0.12);
  color: #00806f;
}
.auth-tab.router-link-active {
  background: #00bea5;
  color: #fff;
}
.auth-tab:focus-visible {
  outline: 2px solid #00bea5;
  outline-offset: 2px;
}
</style>
